import React from 'react';

const Logo = (props) => {
  return (
    <img
      alt="Logo"
      src="/static/base-logo.PNG"
      {...props}
    />
  );
};

export default Logo;
